import { client } from '../api';
import { ALLERGIES_URL } from './constants';

export { useAllergies } from './useAllergies';

export const fetchAllergy = async term => {
  const searchPath = `${ALLERGIES_URL}?term=${term}`;
  const { data } = await client.get(searchPath);
  return data;
};
